import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "documento",
  "use": "documento-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"documento\"><path fill-rule=\"evenodd\" d=\"M11 0h40a3 3 0 0 1 3 3v58a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm2 3a1 1 0 0 0-1 1v56a1 1 0 0 0 1 1h37a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H13zm5.5 11h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3zm0 7h27a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0 7h27a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0 7h27a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0 7h27a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0 7h27a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol